import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import {bindActionCreators} from 'redux';
import style from './style.scss';

import SendButton from '/chat/src/components/SVGImages/SendButton'


class ChatFooterSendButton extends Component {
    constructor() {
        super();
        this.state = {
            hover: false,
        };
        this.handleSendClick = this.handleSendClick.bind(this);
    }

    onHover (e) {
        this.setState({hover: true})
    }
    onHoverLeave (e){
        this.setState({hover: false})
    }

    render(){
        return (
            <div
                onMouseEnter={this.onHover.bind(this)}
                onMouseLeave={this.onHoverLeave.bind(this)}
                onClick={this.handleSendClick}
                className={style.ChatFooterSendButton}>
                <SendButton active={this.state.hover} color={this.props.color}/>
            </div>
        );
    }

    handleSendClick(){
        this.props.onClick();
    }
}

export default connect(null, null, null, {withRef: true})(ChatFooterSendButton);



// WEBPACK FOOTER //
// ./routes/Chat/Chat/ChatFooter/ChatFooterSendButton.js